<template>
    <div class="readmore">
      <router-link :to="url" class="text-decoration-none readmore__button">
        {{ name }} <i class="fas fa-arrow-right readmore__arrow"></i>
      </router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DinamicLink',
    props: {
      url: {
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true
      }
    }
  }
  </script>
  
  <style scoped>
  .readmore {
  }
  
  .readmore__button {
    display: flex;
    align-items: center;
  }
  
  .readmore__arrow {
    margin-left: 5px;
  }
  </style>
  